var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('p',[_c('i',{staticClass:"fa fa-copyright"}),_vm._v(" "+_vm._s(new Date().getFullYear())+" MAS Athena Reservations. All rights reserved.")]),_c('p',[_vm._v("v 1.0")])])])}
var staticRenderFns = []

export { render, staticRenderFns }